var CollectionFilterModel = /** @class */ (function () {
    function CollectionFilterModel(filterType, title, options, mainCollectionId) {
        this.filterType = filterType;
        this.mainCollectionId = mainCollectionId;
        this.title = title;
        this.options = options;
        this.activeOptions = mainCollectionId;
    }
    CollectionFilterModel.prototype.updateActiveOptions = function (optionId) {
        this.activeOptions = optionId;
    };
    CollectionFilterModel.prototype.hasActiveOptions = function () {
        return this.activeOptions !== '';
    };
    CollectionFilterModel.prototype.resetActiveOptions = function () {
        this.updateActiveOptions(this.mainCollectionId);
    };
    return CollectionFilterModel;
}());
export { CollectionFilterModel };
//# sourceMappingURL=CollectionFilterModel.js.map